import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { searchTeams as searchTeamsFromMonolith, SearchTeamsOptions } from '~/monolith-api';

const searchTeamsSchema = z.object({
   searchTerm: z.string(),
   limit: z.number().optional(),
   page: z.number().optional(),
   uniqueOnly: z.boolean().optional(),
   ownerTeamUserid: z.number().optional(),
});

export async function searchTeams(searchTerm: string, options: SearchTeamsOptions | undefined) {
   return await searchTeamsFromMonolith(searchTerm, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { searchTerm, limit, page, uniqueOnly, ownerTeamUserid } = searchTeamsSchema.parse(
         req.body
      );
      const monolithClient = getServerSideMonolithClient(req);
      const result = await searchTeamsFromMonolith(searchTerm, {
         limit,
         page,
         uniqueOnly,
         ownerTeamUserid,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const searchTeamsFromClient = (
   searchTerm: string,
   options?: SearchTeamsOptions
): ReturnType<typeof searchTeams> => {
   return bff()
      .post('/teams/searchTeams', {
         searchTerm,
         ...options,
      })
      .then(response => response.data);
};
